import LiveTripsTracker from "../../components/tracking/LiveTripsTracker";

const LiveTracker = () => {
  return <LiveTripsTracker />;
};

export default LiveTracker;
